module.exports = __webpack_public_path__ + "img/continue_button.f2d12b45.png";